export default () => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Api-Key': process.env.VUE_APP_API_KEY,
  }

  return headers
}
